import { useContext } from 'react';

import { getActiveTabId } from '../utils';
import { HeaderContextValue } from '../header-context';
export const useActiveTab = () => {
    const { items, pathname } = useContext(HeaderContextValue);
    const activeTabId = getActiveTabId(items, pathname);
    return items.find((item) => item.id === activeTabId);
};
